// utils/parseUtils.js
export const parseBlankQuestion = (questionString) => {
  const regex = /(_{2,})/g;
  const result = [];

  let lastIndex = 0;
  let match;
  let blankIndex = 0;

  // questionString에서 underscore 덩어리를 찾으면서 순회
  while ((match = regex.exec(questionString)) !== null) {
    const underscoreGroup = match[0];
    const start = match.index;

    // 매칭된 underscore 이전의 일반 텍스트를 result에 담기
    if (start > lastIndex) {
      result.push({
        type: "text",
        content: questionString.substring(lastIndex, start),
      });
    }

    // underscore 자체를 blank로 인식
    result.push({
      type: "blank",
      length: underscoreGroup.length, // underscore 개수
      index: blankIndex++,
      input: "",
      isSubmitted: false,
      firstAttemptCorrect: undefined,
      firstAttemptAnswer: undefined,
      // 실제로는 length 말고도 식별자 id 등을 넣어도 좋습니다.
    });

    lastIndex = start + underscoreGroup.length;
  }

  // 마지막 underscore 이후의 텍스트가 남아 있다면 넣어주기
  if (lastIndex < questionString.length) {
    result.push({
      type: "text",
      content: questionString.substring(lastIndex),
    });
  }

  return result;
};

export const parseScrambleQuestion = (questionString) => {
  const result = [];

  const match = questionString.match(/\*\*\((.*?)\)\*\*/); // `**()`로 감싼 부분 추출
  let index = 0;
  const questionWordList = match[1].split(" / ").map((word) => {
    return { text: word, index: index++ };
  });

  if (match.index > 0) {
    result.push({
      type: "text",
      content: questionString.substring(0, match.index),
    });
  }

  result.push({
    type: "scramble",
    content: questionWordList,
    length: questionWordList.map((word) => word.text).join(" ").length,
    input: [],
  });
  if (match.index + match[0].length < questionString.length) {
    result.push({
      type: "text",
      content: questionString.substring(match.index + match[0].length),
    });
  }

  return result;
};

export const processGroupData = (data) => {
  return data.flatMap((item) => {
    const tokenIndices = item.token_indices;
    let splitIndices = [];
    let temp = [tokenIndices[0]];

    // 연속적 구간으로 나누기
    for (let i = 1; i < tokenIndices.length; i++) {
      if (tokenIndices[i] === tokenIndices[i - 1] + 1) {
        temp.push(tokenIndices[i]);
      } else {
        splitIndices.push(temp);
        temp = [tokenIndices[i]];
      }
    }
    splitIndices.push(temp);

    // 나누어진 구간별로 새로운 객체 생성
    return splitIndices.map((indices) => ({
      ...item,
      token_indices: indices,
    }));
  });
};

export const parseSummaryBlankQuestion = (questionString) => {
  const regex = /--(.*?)--/g;
  const firstRegex = /\*\*(.*?)\*\*/;
  const result = [];

  let lastIndex = 0;
  let match;
  let blankIndex = 0;

  // questionString에서 underscore 덩어리를 찾으면서 순회
  while ((match = regex.exec(questionString)) !== null) {
    const underscoreGroup = match[0];
    const start = match.index;

    // 매칭된 underscore 이전의 일반 텍스트를 result에 담기
    if (start > lastIndex) {
      result.push({
        type: "text",
        content: questionString.substring(lastIndex, start),
      });
    }

    // underscore 자체를 blank로 인식
    result.push({
      type: "blank",
      length: underscoreGroup.replace("-", "").replace("*", "").length, // underscore 개수
      index: blankIndex++,
      input: "",
      hint: firstRegex.exec(underscoreGroup)[1],
      isSubmitted: false,
      // 실제로는 length 말고도 식별자 id 등을 넣어도 좋습니다.
    });

    lastIndex = start + underscoreGroup.length;
  }

  // 마지막 underscore 이후의 텍스트가 남아 있다면 넣어주기
  if (lastIndex < questionString.length) {
    result.push({
      type: "text",
      content: questionString.substring(lastIndex),
    });
  }

  return result;
};
